jQuery(function ($) {
    //Stap Slider
    $('.stapSlider').owlCarousel({
        loop: true,
        margin: 0,
        dots: false,
        nav: true,
        autoplay: false,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsiveClass: true,
        navText: ['<span class="fa fa-angle-left"></span>','<span class="fa fa-angle-right"></span>'],
        responsive: {
            0: {
                items: 1
            }
        }
    })
    //    < ------------------------------------------------------>
});

jQuery(function ($) {
  var elements = document.getElementsByClassName("stamped-carousel-scroll");
  var element = elements[0];
  console.log(element);
});
